export default function probability(decimal: number) {
  return Math.random() < decimal;
}
